import { isFulfilled, isPending, isRejected } from "./reducerUtils";

let initialState = {
    platformPostListData: [],
    platformPostListLoading: false,
    platformNextCursor: "",
    blockPageIds: [],
    platformId: null,
};

const SMRCommentFilterReducer = (state = initialState, action) => {
    switch (action.type) {
        case isPending("FETCH_COMMENT_POST_LIST"):
            return (state = {
                ...state,
                platformPostListLoading: true,
            });
        case isRejected("FETCH_COMMENT_POST_LIST"):
            return (state = {
                ...state,
                platformPostListLoading: false,
            });

        case isFulfilled("FETCH_COMMENT_POST_LIST"): {
            const postIdsUsingMap = action.payload.data.filters.map((post) => post.post_id);
            return (state = {
                ...state,
                platformPostListLoading: false,
                platformPostListData: action.payload.data.filters,
                blockPageIds: postIdsUsingMap,
            });
        }
        default:
            return state;
    }
};
export default SMRCommentFilterReducer;
